import React, { useEffect } from 'react';
import useStore from '../../../../useStore';
import Loader from '../../../Elements/Loader/Loader';

const VerRegistrarEmpresa = () => {
  const { fetchGetEmpresasRegistros, empresasRegistros, loading } = useStore()

  useEffect(() => {
    fetchGetEmpresasRegistros()
  }, [])

  if (loading) return <Loader />

  return (
    <div className="container mt-4">
      <div className="row mb-3">
        <div className="col">
          <h2 className="text-white">Registros de empresas</h2>
          <span className="text-white">Total: {empresasRegistros?.total || 0}</span>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="table-responsive">
            <table className="table table-striped table-hover table-bordered align-middle table-dark">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo</th>
                  <th>Empresa</th>
                  <th>Fecha de registro</th>
                </tr>
              </thead>
              <tbody>
                {empresasRegistros?.registros?.length > 0 ? (
                  empresasRegistros.registros.map((registro, index) => (
                    <tr key={registro.idEmpresa}>
                      <td>{index + 1}</td>
                      <td>{registro.nombre}</td>
                      <td>{registro.telefono}</td>
                      <td>{registro.correo}</td>
                      <td>{registro.empresa}</td>
                      <td>{new Date(registro.fechaRegistro).toLocaleDateString("es-MX")}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center text-white">
                      No hay registros
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerRegistrarEmpresa